<p-breadcrumb [home]="home" [model]="breadcrumb" styleClass="p-mb-2"></p-breadcrumb>

<div class="layout-people jobsv2-{{ colorScheme.colorScheme.value }}">
  <app-karve-tabview
    [tabs]="tabs"
    baseUrl="/people"
    class="people-tabs"
  ></app-karve-tabview>
  <div class="tabView">
    <router-outlet></router-outlet>
  </div>
</div>